/**
 * @flow
 * @relayHash d66f7ca2d715b393a482fe389d6f9531
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CategorySelectQueryVariables = {||};
export type CategorySelectQueryResponse = {|
  +categoryByOrg: ?{|
    +edges: $ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +name: string,
      |}
    |}>
  |}
|};
export type CategorySelectQuery = {|
  variables: CategorySelectQueryVariables,
  response: CategorySelectQueryResponse,
|};
*/


/*
query CategorySelectQuery {
  categoryByOrg(orderBy: "name") {
    edges {
      node {
        id
        name
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "categoryByOrg",
    "storageKey": "categoryByOrg(orderBy:\"name\")",
    "args": [
      {
        "kind": "Literal",
        "name": "orderBy",
        "value": "name"
      }
    ],
    "concreteType": "CategoryNodeConnection",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "CategoryNodeEdge",
        "plural": true,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "CategoryNode",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "id",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "name",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "CategorySelectQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": (v0/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "CategorySelectQuery",
    "argumentDefinitions": [],
    "selections": (v0/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "CategorySelectQuery",
    "id": null,
    "text": "query CategorySelectQuery {\n  categoryByOrg(orderBy: \"name\") {\n    edges {\n      node {\n        id\n        name\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'd009ea4f5dd94c76930755feabebb828';
module.exports = node;
